<category-component></category-component>
<div class="side-space-wrapper  grey-color fixed-header-height">

  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <ul class="breadcrumbs d-flex pt-3 pt-md-0">
          <li>
            <a routerLink="/" title="Home">Home</a>
          </li>
          <li>
            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
          </li>
          <li>
            My Orders
          </li>
        </ul>
        <a title="back" class="back-listing-btn d-none d-lg-block back-cart" href="javascript:void(0);"><svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Combined Shape</title><desc>Created with Sketch.</desc><g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C" fill-rule="nonzero"><path d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z" id="Combined-Shape"></path></g></g></svg> Back </a>
        <div class="white-bg">
          <h3>My Orders</h3>

          <ul class="store-list current">
            <li>
              <input type="radio" id="test1" name="radio-group" checked>
              <label for="test1">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
          </ul>
          <h3>Select Another Store</h3>
          <ul class="store-list">
            <li>
              <input type="radio" id="test2" name="radio-group">
              <label for="test2">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
            <li>
              <input type="radio" id="test3" name="radio-group">
              <label for="test3">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
            <li>
              <input type="radio" id="test4" name="radio-group">
              <label for="test4">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
            <li>
              <input type="radio" id="test5" name="radio-group">
              <label for="test5">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
            <li>
              <input type="radio" id="test6" name="radio-group">
              <label for="test6">
                Store Name
                <span>Smith’s Mart 1, Shambles, York Y017LZ</span>
              </label>
            </li>
          </ul>
        </div>
        <div class="view-all-order d-flex d-md-none sticky"><a href="javascript:void(0);" class="btn primary-btn"
            title="Continue">Continue</a></div>
        <div class="view-all-order d-none d-md-flex">
          <a class="btn primary-btn" href="javascript:void(0);" title="Continue">Continue</a>
        </div>
      </div>
    </div>
  </div>
</div>
